import service from '@/middleware'

const lineApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     */
    async findAll(pageSize, pageNumber, headers) {
        const url = pageSize != null && pageNumber != null
            ? `/api/lines/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/lines/all?headers=${headers}`
        const response = await service.http.get(url)
        return response
    },
    /**
     * Para cargar los selectores de línea en el ABM de GPS
     */
    async findAllNonAssigned() {
        const response = await service.http.get(`/api/lines/all-non-assigned`)
        return response
    },
    /**
     * Total de líneas para el paginador de la tabla del ABM
     */
    async getTotal () {
        const result = await service.http.get(`/api/lines/total`)
        return result
    },
    /**
     * Estados de línea para el ABM
     */
    async getStates () {
        const result = await service.http.get(`/api/lines/states`)
        return result
    },
    /**
     * Carriers de línea para el ABM
     */
    async getCarriers () {
        const result = await service.http.get(`/api/lines/carriers`)
        return result
    },
    /**
     * Para obtener una línea con el id enviado como param
     * @param {*} lineId
     */
    async getLine (lineId) {
        const result = await service.http.get(`/api/lines/${lineId}`)
        return result
    },
    /**
     * Para validar el número de línea
     * @param {*} lineNumber
     */
    async validateLineNumber (lineNumber) {
        const result = await service.http.get(`/api/lines/validate-line-number/${lineNumber}`)
        return result
    },
    /**
     * Para validar el número de sim card
     * @param {*} simCardNumber
     */
    async validateSimCardNumber (simCardNumber) {
        const result = await service.http.get(`/api/lines/validate-sim-card/${simCardNumber}`)
        return result
    },
    /**
     * Para crear una nueva línea
     * @param {*} lineDto
     */
    async create (lineDto) {
        const result = await service.http.post(`/api/lines/create`, lineDto)
        return result
    },
    /**
     * Para actualizar una línea
     * @param {*} lineDto
     */
    async update (lineDto) {
        const result = await service.http.put(`/api/lines/update`, lineDto)
        return result
    },
    /**
     * Para eliminar una línea
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/lines/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/lines/multiple-delete`, ids)
        return result
    },
}

export default lineApi
